(function () {
  if (window.__ossOfferReady) return;
  window.__ossOfferReady = true;

  function usd(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(Math.max(0, Number(cents || 0)) / 100);
  }

  function offerSubtotal(cart, card) {
    if (cart) {
      if (cart.items_subtotal_price != null) return Number(cart.items_subtotal_price || 0);
      if (cart.original_total_price != null) return Number(cart.original_total_price || 0);
    }
    return Number(card.getAttribute('data-offer-subtotal-cents') || 0);
  }

  function gardenDiscount(cart, card) {
    if (!cart || !Array.isArray(cart.cart_level_discount_applications)) {
      return Number(card.getAttribute('data-garden-discount-cents') || 0);
    }
    return cart.cart_level_discount_applications.reduce(function (total, entry) {
      var application = entry && (entry.discount_application || entry);
      var title = String(application && application.title || '').trim().toLowerCase();
      var isGarden = title === 'garden savings: auto 10% off orders $15+';
      var amount = application && application.total_allocated_amount != null ? application.total_allocated_amount : entry && entry.amount;
      return total + (isGarden ? Math.max(0, Number(amount) || 0) : 0);
    }, 0);
  }

  function discountedMerchandise(cart) {
    // Mutation responses can include a previously selected checkout shipping charge
    // in total_price. Use Shopify's merchandise subtotal and actual allocations;
    // never calculate a discount percentage or subtract a guessed shipping rate.
    if (cart.items_subtotal_price == null || !Array.isArray(cart.cart_level_discount_applications)) return Number(cart.total_price || 0);
    var allocated = cart.cart_level_discount_applications.reduce(function (sum, entry) {
      var application = entry && (entry.discount_application || entry);
      if (!application || application.target_type === 'shipping_line') return sum;
      var amount = application.total_allocated_amount != null ? application.total_allocated_amount : entry.amount;
      return sum + Math.max(0, Number(amount) || 0);
    }, 0);
    return Math.max(0, Number(cart.items_subtotal_price || 0) - allocated);
  }

  var offerConfig = document.querySelector('[data-oss-offer]');
  var latestOfferCart = null;
  var serverConfirmed = !!document.querySelector('[data-oss-server-subscription-success]');
  var serverEligible = !!document.querySelector('[data-oss-subscriber-eligible="true"]');
  // Native success or Shopify's logged-in customer marketing consent is evidence.
  // A submit, click, URL parameter or public code is never confirmation. No PII stored.
  if (serverConfirmed) {
    try { sessionStorage.setItem('oss_subscriber_confirmed', 'true'); } catch (error) {}
  }
  var snapshot = document.querySelector('[data-oss-offer-cart]');
  if (snapshot) {
    try { latestOfferCart = JSON.parse(snapshot.textContent); } catch (error) {}
  }
  function subscriberConfirmed() {
    if (serverConfirmed || serverEligible) return true;
    try { return sessionStorage.getItem('oss_subscriber_confirmed') === 'true'; } catch (error) { return false; }
  }
  var offerUnlockMemory = false;
  function is20OffUnlocked() {
    try { return window.localStorage.getItem('oss_20off_unlocked') === 'true'; }
    catch (error) { return offerUnlockMemory === true; }
  }
  function unlock20Off() {
    var unlockedAt = Date.now().toString();
    try {
      window.localStorage.setItem('oss_20off_unlocked', 'true');
      window.localStorage.setItem('oss_20off_unlocked_at', unlockedAt);
      if (window.localStorage.getItem('oss_20off_unlocked') !== 'true') throw new Error('localStorage readback failed');
      offerUnlockMemory = true;
      return true;
    } catch (error) {
      // Private browsing, blocked storage, or a browser policy can make
      // localStorage unavailable. Keep this tab eligible without storing PII.
      offerUnlockMemory = true;
      try { console.warn('[OSS] 20% offer localStorage unavailable; using memory fallback.', error); } catch (logError) {}
      return true;
    }
  }
  var autoInFlight = false;
  var autoScheduled = false;
  var autoAttempts = [];
  var legacyAutoAttempts = [];
  var autoSuppressed = '';
  try {
    var savedAttempts = JSON.parse(sessionStorage.getItem('oss_grow20_apply_attempted') || '[]');
    if (Array.isArray(savedAttempts)) autoAttempts = savedAttempts.filter(function (key) { return typeof key === 'string'; });
    var legacyAttempts = JSON.parse(sessionStorage.getItem('oss_grow20_auto_attempts_v1') || '[]');
    if (Array.isArray(legacyAttempts)) legacyAutoAttempts = legacyAttempts;
    autoSuppressed = sessionStorage.getItem('oss_grow20_auto_removed_v1') || '';
  } catch (error) {}
  function fingerprint(value) {
    var hash = 2166136261;
    for (var i = 0; i < value.length; i++) hash = Math.imul(hash ^ value.charCodeAt(i), 16777619);
    return (hash >>> 0).toString(16);
  }
  function autoCartId(cart) { return fingerprint(String(cart && cart.token || 'this-session')); }
  function autoKey(cart, total) {
    return fingerprint(JSON.stringify([autoCartId(cart), total, cart && cart.items_subtotal_price,
      (cart && cart.items || []).map(function (item) { return [item.variant_id, item.quantity, item.properties, item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id]; }),
      (cart && cart.discount_codes || []).filter(function (entry) { return String(entry.code || '').toUpperCase() !== 'GROW20'; }).map(function (entry) { return entry.code; }).sort()]));
  }
  function rememberAutoAttempt(cart) {
    // One automatic attempt per cart in this tab session, not per quantity/amount.
    // This is a request latch only; it never means the discount is applied.
    var key = autoCartId(cart);
    if (autoAttempts.indexOf(key) === -1) autoAttempts.push(key);
    try { sessionStorage.setItem('oss_grow20_apply_attempted', JSON.stringify(autoAttempts)); } catch (error) {}
  }
  function codeAllocations(cart) {
    return (cart && cart.cart_level_discount_applications || []).map(function (entry) {
      var app = entry && (entry.discount_application || entry);
      return {
        code: String(app && app.title || '').trim(),
        type: app && app.type,
        target: app && app.target_type,
        amount: Math.max(0, Number(app && app.total_allocated_amount != null ? app.total_allocated_amount : entry && entry.amount) || 0)
      };
    }).filter(function (app) { return app.type === 'discount_code' && app.amount > 0; });
  }
  function getState(cart) {
    cart = cart || latestOfferCart;
    var code = offerConfig ? offerConfig.getAttribute('data-offer-code') : 'GROW20';
    var percent = offerConfig ? Number(offerConfig.getAttribute('data-offer-percent')) : 20;
    var minimum = offerConfig ? Number(offerConfig.getAttribute('data-offer-minimum-cents')) : 1990;
    var subtotal = offerConfig ? offerSubtotal(cart, offerConfig) : Number(cart && cart.items_subtotal_price || 0);
    var discountedSubtotal = cart ? discountedMerchandise(cart) : subtotal;
    var remaining = Math.max(0, minimum - subtotal);
    var shippingRemaining = Math.max(0, 1990 - subtotal);
    var gardenRemaining = Math.max(0, 1500 - subtotal);
    var amount = codeAllocations(cart).reduce(function (sum, app) {
      return sum + (app.code.toUpperCase() === code.toUpperCase() && app.target !== 'shipping_line' ? app.amount : 0);
    }, 0);
    var confirmed = subscriberConfirmed();
    var unlocked = is20OffUnlocked();
    // Shopping eligibility is the local offer entitlement only. Marketing
    // confirmation remains separate and never substitutes for this helper.
    var subscribed = unlocked;
    var fallback = !autoInFlight && (autoAttempts.indexOf(autoCartId(cart)) !== -1 || autoSuppressed === autoCartId(cart));
    // A valid newsletter submit unlocks the shopping offer immediately.
    // Marketing subscriber eligibility remains a separate backend-confirmed flag.
    var name = amount > 0 ? 'GROW20_APPLIED' : gardenRemaining > 0 ? 'BELOW_GARDEN_THRESHOLD' : remaining > 0 ? 'BELOW_GROW20_THRESHOLD' : 'GROW20_READY_TO_APPLY';
    var isD = name === 'GROW20_APPLIED';
    var level = isD ? 4 : gardenRemaining > 0 ? 1 : remaining > 0 ? 2 : 3;
    return {
      name: name, code: code, percent: percent, minimum: minimum, subtotal: subtotal,
      remaining: remaining, shippingRemaining: shippingRemaining, merchandiseRemaining: Math.max(0, minimum - subtotal), discountedSubtotal: discountedSubtotal,
      gardenRemaining: gardenRemaining, amount: amount, subscribed: subscribed, confirmed: confirmed, unlocked: unlocked, autoApplying: autoInFlight, autoFallback: fallback,
      level: level,
      gardenAmount: gardenDiscount(cart, offerConfig || document.createElement('div')),
      join: !subscribed && !isD, continueShopping: subscribed && !isD && remaining > 0,
      apply: subscribed && !isD && remaining === 0 && fallback,
      copy: subscribed && !isD && remaining > 0,
      // A cart-scoped unlock hides the cart CTA but must not hide the email
      // fields before the buyer has submitted them. Only persistent backend
      // confirmation (or an already applied offer) renders the success view.
      showSuccess: confirmed || isD,
      heading: !subscribed && !isD ? 'Save ' + percent + '% on orders $' + (minimum / 100).toFixed(2) + '+' : 'Your ' + percent + '% code is ready',
      message: !subscribed && !isD ? ''
        : remaining > 0 ? (unlocked && !confirmed ? 'Your 20% savings are unlocked for this cart. Add ' + usd(remaining) + ' more to qualify.' : 'Subscribed. Add ' + usd(remaining) + ' more to unlock ' + percent + '% off.')
        : fallback ? 'Your 20% discount is ready.' : 'Applying your 20% discount…',
      // A rejected Ajax code does not identify the cause. Do not assert an activation delay.
      helper: subscribed && !isD && remaining === 0 && fallback ? 'If you just subscribed, your savings may still be activating. Please try again in a moment.' : '',
      successHeading: 'Your 20% savings are unlocked!',
      successDescription: 'Your savings will apply automatically in your cart.'
    };
  }
  function discountFeedback(cart, codes) {
    var state = getState(cart);
    var allocations = codeAllocations(cart);
    var missing = codes.filter(function (code) {
      return !allocations.some(function (app) { return app.code.toUpperCase() === code.toUpperCase(); });
    });
    if (!missing.length) return { success: true, retry: false, message: 'Discount applied in this cart.' };
    var includesOffer = missing.some(function (code) { return code.toUpperCase() === state.code.toUpperCase(); });
    var message = 'This code was not applied. Check the code and its terms, or try another code.';
    var retry = false;
    if (includesOffer) {
      if (state.merchandiseRemaining > 0) message = 'Add ' + usd(state.merchandiseRemaining) + ' more to reach ' + usd(state.minimum) + '. ' + state.code + ' is for email subscribers only.';
      else if (!state.subscribed) message = state.code + ' is for email subscribers. Join the Garden Club, or use your subscribed email at checkout. One use per customer.';
      else {
        // Ajax does not identify why a code was rejected. Never assert a known
        // activation delay or retry automatically without Shopify evidence.
        message = 'Your subscriber savings may still be activating. Use your subscribed email at checkout and check the one-use limit. Please try again in a moment.';
        retry = true;
      }
    }
    if (missing.length < codes.length) message = 'Some codes were applied; review Applied codes. ' + message;
    return { success: false, retry: retry, message: message };
  }
  function renderFeedback(scope, cart, codes) {
    if (!scope) return;
    scope.ossDiscountAttempt = codes;
    var feedback = discountFeedback(cart, codes);
    var message = scope.querySelector('[data-oss-cart-discount-message], [data-oss-ajax-cart-discount-message]');
    if (message) {
      message.textContent = feedback.success && getState(cart).level === 4 ? '' : feedback.message;
      message.classList.toggle('is-success', feedback.success);
      message.classList.toggle('is-error', !feedback.success);
    }
    var button = scope.querySelector('[data-oss-cart-discount-submit], button[type="submit"]');
    if (button) button.textContent = feedback.retry ? 'Try Again' : 'Apply';
  }
  window.ossSubscriberDiscount = { getState: getState, feedback: discountFeedback, renderFeedback: renderFeedback };

  function syncDrawerApplyAvailability() {
    var busy = window.ossCartTransactions && window.ossCartTransactions.isBusy();
    document.querySelectorAll('.oss-offer-card--drawer [data-oss-offer-apply]').forEach(function (link) {
      link.setAttribute('aria-disabled', String(!!busy));
      if (busy) link.setAttribute('tabindex', '-1');
      else link.removeAttribute('tabindex');
    });
  }
  function updateOffer(card, state) {
    var drawer = card.classList.contains('oss-offer-card--drawer');
    if (drawer) {
      var joinStatus = card.querySelector('[data-oss-offer-join]');
      var status = card.querySelector('[data-oss-offer-drawer-status]');
      var helper = card.querySelector('[data-oss-offer-drawer-helper]');
      var applied = state.name === 'GROW20_APPLIED';
      var showJoinPrompt = !state.subscribed && !applied;
      card.hidden = state.subtotal <= 0 || state.subscribed || applied;
      card.setAttribute('data-offer-state', state.name);
      card.setAttribute('data-offer-level', String(state.level));
      card.setAttribute('data-offer-subtotal-cents', String(state.subtotal));
      if (joinStatus) {
        joinStatus.hidden = !showJoinPrompt;
        joinStatus.disabled = !showJoinPrompt;
        if (status) {
          status.textContent = showJoinPrompt
            ? 'Save 20% on orders $19.90+'
            : '';
          if (showJoinPrompt) joinStatus.setAttribute('aria-label', 'Subscribe and save 20%');
        }
        if (helper) {
          helper.textContent = showJoinPrompt ? card.getAttribute('data-subscriber-replaces') : '';
          helper.hidden = !showJoinPrompt;
        }
      }
      return;
    }
    var subscriberAction = drawer && state.subscribed;
    card.toggleAttribute('data-oss-subscriber-action', subscriberAction);
    // An applied offer belongs only in the actual amount summary, not a second card.
    card.hidden = state.subscribed || state.name === 'GROW20_APPLIED';
    card.setAttribute('data-offer-state', state.name);
    card.setAttribute('data-offer-level', String(state.level));
    card.setAttribute('data-offer-subtotal-cents', String(state.subtotal));
    card.querySelector('[data-oss-offer-heading]').textContent = state.heading;
    var joinButton = card.querySelector('[data-oss-offer-join]');
    if (joinButton) joinButton.textContent = 'Subscribe & Save 20%';
    // The Drawer progress already explains the next goal; keep only its small action here.
    card.querySelector('.oss-offer-card__message').hidden = subscriberAction && !state.helper;
    card.querySelector('[data-oss-offer-heading]').hidden = subscriberAction;
    var message = card.querySelector('[data-oss-offer-message]');
    message.textContent = state.message;
    message.hidden = subscriberAction || !state.message;
    var helper = card.querySelector('[data-oss-offer-helper]');
    var helperText = state.join ? card.getAttribute('data-discount-replaces') : state.helper;
    if (helper) { helper.textContent = helperText; helper.hidden = !helperText; }
    var join = card.querySelector('[data-oss-offer-join]');
    if (join) join.hidden = !state.join;
    var continueLink = card.querySelector('[data-oss-offer-continue]');
    if (continueLink) continueLink.hidden = drawer || !state.continueShopping;
    var applyLink = card.querySelector('[data-oss-offer-apply]');
    if (applyLink) applyLink.hidden = !state.apply;
    if (drawer) syncDrawerApplyAvailability();
    var copyButton = card.querySelector('[data-oss-offer-copy]');
    if (copyButton) copyButton.hidden = true;
    card.querySelector('.oss-offer-card__actions').hidden = state.name === 'GROW20_APPLIED';
  }

  function renderSavingsProgress(state) {
    document.querySelectorAll('[data-oss-savings-progress]').forEach(function (group) {
      group.hidden = state.subtotal <= 0;
      ['garden', 'subscriber'].forEach(function (kind) {
        var panel = group.querySelector('[data-oss-savings="' + kind + '"]');
        if (!panel) return;
        var garden = kind === 'garden';
        var minimum = garden ? 1500 : state.minimum;
        var applied = garden ? state.gardenAmount > 0 : state.amount > 0;
        var unlocked = state.subtotal >= minimum;
        var remaining = Math.max(0, minimum - state.subtotal);
        var percent = Math.min(100, Math.max(0, state.subtotal / minimum * 100));
        panel.hidden = garden ? state.amount > 0 : true;
        panel.querySelector('[data-oss-savings-status]').textContent = applied ? '✓ Applied' : unlocked ? '✓ Unlocked' : usd(state.subtotal) + ' of ' + usd(minimum);
        var bar = panel.querySelector('[role="progressbar"]');
        bar.setAttribute('aria-valuenow', String(Math.round(percent * 10) / 10));
        bar.setAttribute('aria-valuetext', applied ? 'Applied' : unlocked ? 'Unlocked' : usd(state.subtotal) + ' of ' + usd(minimum));
        bar.firstElementChild.style.width = percent + '%';
        var message = panel.querySelector('[data-oss-savings-message]');
        message.textContent = garden
          ? applied ? "You're saving 10% automatically." : unlocked ? 'Your automatic savings are ready.' : 'Add ' + usd(remaining) + ' more to unlock 10% Garden Savings.'
          : applied ? '' : unlocked ? state.autoApplying ? 'Applying your 20% discount…' : state.autoFallback ? 'Your 20% discount is ready.' : 'Checking your subscriber savings…' : 'Add ' + usd(remaining) + ' more to upgrade your savings to ' + state.percent + '%.';
        message.hidden = !message.textContent;
      });
    });
  }

  function renderCodeSummary(cart, state) {
    var codes = codeAllocations(cart);
    var allCodeAmount = codes.reduce(function (sum, app) { return sum + app.amount; }, 0);
    document.querySelectorAll('[data-oss-ajax-cart-code-discount], [data-oss-cart-code-discount]').forEach(function (row) {
      var label = row.querySelector('[data-oss-ajax-cart-code-label], [data-oss-cart-code-label]');
      var value = row.querySelector('[data-oss-ajax-cart-code-value], [data-oss-cart-code-value]');
      var growApplied = state.name === 'GROW20_APPLIED';
      var amount = growApplied ? state.amount : allCodeAmount;
      if (cart && row.hasAttribute('data-oss-cart-code-discount')) {
        amount = Math.max(0, Number(cart.items_subtotal_price || 0) - discountedMerchandise(cart));
      }
      row.hidden = amount <= 0;
      row.style.display = amount > 0 ? '' : 'none';
      label.textContent = 'Your discount';
      value.textContent = amount > 0 ? '-' + usd(amount) : '';
    });
  }

  function renderDrawerSummary(cart) {
    if (!cart) return;
    var original = Math.max(0, Number(cart.items_subtotal_price || 0));
    var current = discountedMerchandise(cart);
    var savings = Math.max(0, original - current);
    document.querySelectorAll('[data-oss-ajax-cart-merchandise-subtotal]').forEach(function (node) {
      node.textContent = usd(original);
    });
    document.querySelectorAll('[data-oss-ajax-cart-subtotal]').forEach(function (node) {
      node.textContent = usd(current);
    });
    document.querySelectorAll('[data-oss-ajax-cart-savings]').forEach(function (row) {
      row.hidden = savings <= 0;
      row.style.display = savings > 0 ? '' : 'none';
      var value = row.querySelector('[data-oss-ajax-cart-savings-value]');
      if (value) value.textContent = savings > 0 ? '-' + usd(savings) : '';
    });
  }

  function renderCartJourney(state) {
    document.querySelectorAll('[data-oss-ajax-cart], .oss-cart-page').forEach(function (surface) {
      surface.setAttribute('data-oss-cart-level', String(state.level));
      surface.toggleAttribute('data-oss-cart-empty', state.subtotal <= 0);
      var wrap = surface.querySelector('[data-oss-cart-discount-wrap], [data-oss-ajax-cart-discount-wrap]');
      if (!wrap) return;
      // The conversion cart has one subscription entry point. Keep manual code
      // entry and copy/remove controls out of the customer journey while the
      // internal GROW20 code can still be applied automatically.
      wrap.hidden = true;
      wrap.setAttribute('aria-hidden', 'true');
      surface.removeAttribute('data-oss-code-entry');
    });
  }

  function sync(cart) {
    if (cart && cart.token && Array.isArray(cart.items)) {
      // Preserve an earlier attempt during rollout and an already-applied cart
      // across later quantity reductions. Neither flag can fabricate Applied UI.
      if (getState(cart).amount > 0 || legacyAutoAttempts.indexOf(autoKey(cart, discountedMerchandise(cart))) !== -1) rememberAutoAttempt(cart);
    }
    if (cart) syncAppliedCodes(cart);
    if (cart) latestOfferCart = cart;
    var state = getState(cart || latestOfferCart);
    var merchandiseTotal = cart ? discountedMerchandise(cart) : null;
    if (cart) document.querySelectorAll('[data-oss-ajax-cart-subtotal], [data-oss-cart-final-total]').forEach(function (node) {
      node.textContent = usd(merchandiseTotal);
    });
    var shipping = document.querySelector('[data-oss-shipping-total-cents]');
    if (shipping) {
      var total = cart ? Number(cart.items_subtotal_price || 0) : Number(shipping.getAttribute('data-oss-shipping-total-cents') || 0);
      var count = cart ? Number(cart.item_count || 0) : Number(shipping.getAttribute('data-oss-shipping-count') || 0);
      shipping.setAttribute('data-oss-shipping-total-cents', String(total));
      shipping.setAttribute('data-oss-shipping-count', String(count));
      var ratio = Math.min(100, Math.floor(total / 1990 * 100));
      var shippingMessage = total >= 1990
        ? 'Free U.S. Shipping unlocked'
        : state.subscribed
          ? 'Add ' + usd(state.shippingRemaining) + ' more to unlock 20% off + free shipping.'
          : 'Add ' + usd(state.shippingRemaining) + ' more to unlock free shipping';
      var shippingHint = shipping.getAttribute('data-oss-shipping-basis');
      document.querySelectorAll('[data-oss-ajax-cart-ship-text], [data-oss-cart-progress-message]').forEach(function (node) {
        node.textContent = count ? shippingMessage : 'Your cart is empty.';
      });
      document.querySelectorAll('[data-oss-ajax-cart-ship-ratio], [data-oss-cart-progress-total]').forEach(function (node) {
        node.textContent = usd(total) + ' of $19.90';
      });
      document.querySelectorAll('[data-oss-ajax-cart-ship-hint], [data-oss-cart-progress-hint]').forEach(function (node) {
        node.textContent = count ? shippingHint : 'Your cart is empty.';
      });
      var fill = shipping.querySelector('[data-oss-ajax-cart-ship-fill]');
      if (fill) fill.style.width = ratio + '%';
      var progress = document.querySelector('.oss-cart-progress--top');
      if (progress) progress.style.setProperty('--oss-progress', ratio + '%');
      var drawer = shipping.closest('[data-oss-ajax-cart]');
      if (drawer) drawer.classList.toggle('is-below-free-shipping', count > 0 && total < 1990);
    }
    document.querySelectorAll('[data-oss-garden-summary]').forEach(function (row) {
      var amount = gardenDiscount(cart, row);
      var belowGarden = getState(cart).gardenRemaining > 0;
      row.setAttribute('data-garden-discount-cents', String(amount));
      row.hidden = amount <= 0 || belowGarden || getState(cart).amount > 0;
      row.style.display = row.hidden ? 'none' : '';
      row.querySelector('[data-oss-garden-summary-value]').textContent = row.hidden ? '' : '-' + usd(amount);
    });
    renderDrawerSummary(cart || latestOfferCart);
    renderCodeSummary(cart || latestOfferCart, state);
    renderCartJourney(state);
    renderSavingsProgress(state);
    document.querySelectorAll('[data-oss-offer]').forEach(function (card) { updateOffer(card, state); });
    if (cart) document.querySelectorAll('[data-oss-cart-discount-wrap], [data-oss-ajax-cart-discount-wrap]').forEach(function (scope) {
      if (scope.ossDiscountAttempt && !scope.querySelector('[aria-busy="true"]') && scope.getAttribute('aria-busy') !== 'true') renderFeedback(scope, cart, scope.ossDiscountAttempt);
    });
    document.dispatchEvent(new CustomEvent('oss:subscriber-discount-state', { detail: state }));
    scheduleAutoApply();
  }

  function cartIsOpen() {
    return !!document.querySelector('.oss-cart-page, [data-oss-ajax-cart].is-open');
  }
  function offerDiscountPath(codes) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    var encoded = codes.map(function (code) { return encodeURIComponent(code); }).join(',');
    return 'discount/' + encoded + '?redirect=' + encodeURIComponent(root + 'cart.js');
  }
  function scheduleAutoApply() {
    if (autoScheduled || autoInFlight) return;
    autoScheduled = true;
    window.setTimeout(function () {
      autoScheduled = false;
      syncDrawerApplyAvailability();
      autoApply();
    }, 0);
  }
  async function autoApply() {
    var cart = latestOfferCart;
    var state = getState(cart);
    var transactions = window.ossCartTransactions;
    // Wait for a complete confirmed cart, not a Liquid snapshot or an unfinished mutation.
    if (!cartIsOpen() || !state.subscribed || state.amount > 0 || state.remaining > 0 ||
        !cart || !cart.token || !Array.isArray(cart.items) || !cart.items.length || autoInFlight ||
        autoSuppressed === autoCartId(cart) || !transactions || transactions.isBusy() ||
        document.querySelector('[data-oss-ajax-cart-discount-form][aria-busy="true"], [data-oss-cart-discount-wrap][aria-busy="true"]')) return;
    var key = autoCartId(cart);
    if (autoAttempts.indexOf(key) !== -1 || !transactions.begin()) return;
    // Persist BEFORE writing. Refresh/reopening/unknown results cannot resend this attempt.
    rememberAutoAttempt(cart);
    autoInFlight = true;
    sync();
    var codes = (cart.discount_codes || []).map(function (entry) { return entry.code; }).filter(Boolean);
    confirmedCodes.forEach(function (code) {
      if (!codes.some(function (value) { return value.toUpperCase() === code.toUpperCase(); })) codes.push(code);
    });
    if (!codes.some(function (code) { return code.toUpperCase() === state.code.toUpperCase(); })) codes.push(state.code);
    var controller = new AbortController();
    var finished = false;
    var revision = transactions.version();
    function finish() {
      if (finished) return;
      finished = true;
      window.clearTimeout(deadline);
      controller.abort();
      autoInFlight = false;
      // Release only our discount attempt, never a later cart mutation.
      if (transactions.version() === revision) transactions.end();
      sync();
    }
    // A discount-only uncertainty must not block Checkout. Shopify recalculates
    // the discount there; quantity/add/remove retain their existing protection.
    var deadline = window.setTimeout(finish, 4500);
    async function applyViaExistingDiscountRoute() {
      if (finished || transactions.version() !== revision) return null;
      try {
        var routed = await transactions.request(offerDiscountPath(codes), null, { signal: controller.signal, timeoutMs: 3000 });
        if (finished || transactions.version() !== revision) return null;
        rememberAutoAttempt(routed);
        await transactions.accept(routed);
        return routed;
      } catch (routeError) {
        return null;
      }
    }
    try {
      var result = await transactions.request('cart/update.js', { discount: codes.join(',') }, { signal: controller.signal, timeoutMs: 3000 });
      if (finished || transactions.version() !== revision) return;
      // Shopify may normalize other codes/allocations even when GROW20 is rejected.
      // That response is the same attempt, not a user-created new cart to retry.
      rememberAutoAttempt(result);
      await transactions.accept(result);
      // Keep the existing Shopify discount architecture as the primary path.
      // If cart/update returns only the automatic Garden discount, retry the
      // same code through Shopify's native /discount route before checkout.
      if (getState(result).amount <= 0) await applyViaExistingDiscountRoute();
    } catch (error) {
      var routed = await applyViaExistingDiscountRoute();
      if (!routed && !error.definite && !finished && transactions.version() === revision) {
        // An unknown write result gets one read, never another automatic write.
        try {
          var confirmed = await transactions.request('cart.js', null, { signal: controller.signal });
          if (!finished && transactions.version() === revision) {
            rememberAutoAttempt(confirmed);
            await transactions.accept(confirmed);
          }
        } catch (readError) { /* Keep the actual last-confirmed cart and offer a manual fallback. */ }
      }
    } finally {
      finish();
    }
  }

  async function prepareCheckoutDiscount() {
    var transactions = window.ossCartTransactions;
    if (!transactions) return { eligible: false, applied: false, reason: 'cart-transactions-unavailable' };
    var cart;
    try {
      // Buy Now bypasses the cart drawer, so refresh the confirmed cart after
      // cart/add.js and apply the subscriber code before checkout navigation.
      cart = await transactions.request('cart.js', null, { timeoutMs: 3000 });
      await transactions.accept(cart);
      var state = getState(cart);
      if (!state.subscribed || state.amount > 0 || state.remaining > 0 || !cart.items || !cart.items.length) {
        return { eligible: state.subscribed && state.remaining === 0, applied: state.amount > 0, code: state.code };
      }
      if (autoSuppressed === autoCartId(cart)) return { eligible: true, applied: false, code: state.code, reason: 'removed-by-customer' };
      var codes = (cart.discount_codes || []).map(function (entry) { return entry.code; }).filter(Boolean);
      confirmedCodes.forEach(function (code) {
        if (!codes.some(function (value) { return value.toUpperCase() === code.toUpperCase(); })) codes.push(code);
      });
      if (state.code && !codes.some(function (code) { return code.toUpperCase() === state.code.toUpperCase(); })) codes.push(state.code);
      var result = await transactions.request('cart/update.js', { discount: codes.join(',') }, { timeoutMs: 3000 });
      await transactions.accept(result);
      if (getState(result).amount <= 0) {
        var routed = await transactions.request(offerDiscountPath(codes), null, { timeoutMs: 3000 });
        await transactions.accept(routed);
        result = routed;
      }
      var appliedState = getState(result);
      return { eligible: true, applied: appliedState.amount > 0, code: appliedState.code, cart: result };
    } catch (error) {
      return { eligible: true, applied: false, failed: true, code: 'GROW20' };
    }
  }

  function copyText(value) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(value);
    }
    return new Promise(function (resolve, reject) {
      var input = document.createElement('textarea');
      input.value = value;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      try {
        if (!document.execCommand('copy')) throw new Error('Copy failed');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        input.remove();
      }
    });
  }

  var confirmedCodes = codeAllocations(latestOfferCart).map(function (app) { return app.code; });
  function syncAppliedCodes(cart) {
    var state = getState(cart);
    confirmedCodes = (cart.discount_codes || []).filter(function (entry) {
      return entry && entry.applicable && entry.code &&
        (String(entry.code).toUpperCase() !== state.code.toUpperCase() || state.amount > 0);
    }).map(function (entry) { return String(entry.code); });
    codeAllocations(cart).forEach(function (app) {
      if (!confirmedCodes.some(function (code) { return code.toUpperCase() === app.code.toUpperCase(); })) confirmedCodes.push(app.code);
    });
    document.querySelectorAll('[data-oss-applied-codes]').forEach(function (node) {
      node.replaceChildren();
      node.hidden = confirmedCodes.length === 0;
      confirmedCodes.forEach(function (code) {
        var row = document.createElement('div');
        var text = document.createElement('span');
        text.textContent = 'Applied: ' + code;
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = 'Remove';
        remove.setAttribute('aria-label', 'Remove discount ' + code);
        remove.setAttribute('data-oss-discount-remove', code);
        row.append(text, remove);
        node.appendChild(row);
      });
    });
  }

  function removeDiscount(button) {
    var transactions = window.ossCartTransactions;
    if (!transactions || !transactions.begin()) return;
    var code = button.getAttribute('data-oss-discount-remove');
    if (code.toUpperCase() === getState().code.toUpperCase()) {
      // Respect explicit removal; do not immediately reapply behind the user's back.
      autoSuppressed = autoCartId(latestOfferCart);
      try { sessionStorage.setItem('oss_grow20_auto_removed_v1', autoSuppressed); } catch (error) {}
    }
    var remaining = confirmedCodes.filter(function (value) { return value.toUpperCase() !== code.toUpperCase(); });
    var scope = button.closest('[data-oss-cart-discount-wrap], [data-oss-ajax-cart-discount-wrap]');
    delete scope.ossDiscountAttempt;
    var message = scope.querySelector('[data-oss-cart-discount-message], [data-oss-ajax-cart-discount-message]');
    button.disabled = true;
    message.textContent = 'Removing code...';
    transactions.request('cart/update.js', { discount: remaining.join(',') })
      .then(function (cart) { return transactions.accept(cart); })
      .then(function () {
        var removed = !confirmedCodes.some(function (value) { return value.toUpperCase() === code.toUpperCase(); });
        message.textContent = removed ? 'Code removed.' : 'Shopify still lists this code. Please review it at checkout.';
        if (removed) document.querySelectorAll('[data-oss-cart-discount-input], [data-oss-ajax-cart-discount-input]').forEach(function (input) {
          input.value = input.value.split(',').map(function (value) { return value.trim(); }).filter(function (value) {
            return value && value.toUpperCase() !== code.toUpperCase();
          }).join(', ');
        });
      }).catch(async function (error) {
        if (!error.definite) {
          try { await transactions.refresh(); } catch (refreshError) { transactions.markUnconfirmed(); }
        }
        message.textContent = 'We couldn’t confirm removal. Review Applied codes before trying again.';
      }).finally(function () { button.disabled = false; transactions.end(); });
  }

  function openNewsletter(button) {
    if (typeof window.ossOpenSubscribePopup !== 'function') return;
    var drawer = button.closest('[data-oss-ajax-cart].is-open');
    var teaserButton = document.querySelector('[data-oss-subscribe-open]');

    if (!drawer) {
      window.ossOpenSubscribePopup({ source: button.closest('.oss-cart-page') ? 'cart_page' : 'offer' });
      return;
    }

    var drawerClose = drawer.querySelector('[data-oss-ajax-cart-close]');
    if (!drawerClose) return;
    drawerClose.click();
    window.requestAnimationFrame(function () {
      if (teaserButton) teaserButton.focus({ preventScroll: true });
      // Keep success open; its X and View Cart actions can return to this drawer.
      var opened = window.ossOpenSubscribePopup({ source: 'cart_drawer' });
      if (!opened && typeof window.ossOpenAjaxCart === 'function') window.ossOpenAjaxCart();
    });
  }

  document.addEventListener('click', function (event) {
    var drawerApply = event.target.closest && event.target.closest('.oss-offer-card--drawer [data-oss-offer-apply]');
    if (drawerApply && window.ossCartTransactions && window.ossCartTransactions.isBusy()) {
      event.preventDefault();
      return;
    }
    var toggle = event.target.closest && event.target.closest('[data-oss-discount-toggle]');
    if (toggle) {
      event.preventDefault();
      var wrap = toggle.closest('[data-oss-cart-discount-wrap], [data-oss-ajax-cart-discount-wrap]');
      var editor = wrap.querySelector('[data-oss-discount-editor]');
      editor.hidden = !editor.hidden;
      wrap.closest('[data-oss-ajax-cart], .oss-cart-page').toggleAttribute('data-oss-code-entry', !editor.hidden);
      toggle.setAttribute('aria-expanded', String(!editor.hidden));
      toggle.textContent = 'Discount code';
      if (!editor.hidden) editor.querySelector('input').focus({ preventScroll: true });
      return;
    }
    var removeButton = event.target.closest && event.target.closest('[data-oss-discount-remove]');
    if (removeButton) { event.preventDefault(); removeDiscount(removeButton); return; }
    var joinButton = event.target.closest && event.target.closest('[data-oss-offer-join]');
    if (joinButton) {
      event.preventDefault();
      openNewsletter(joinButton);
      return;
    }

    var continueLink = event.target.closest && event.target.closest('[data-oss-offer-continue]');
    var openDrawer = continueLink && continueLink.closest('[data-oss-ajax-cart].is-open');
    if (openDrawer) {
      event.preventDefault();
      openDrawer.querySelector('[data-oss-ajax-cart-close]').click();
      return;
    }

    var button = event.target.closest && event.target.closest('[data-oss-offer-copy]');
    if (!button) return;
    var state = getState();
    if (!state.copy && !button.closest('[data-oss-subscribe-success]')) return;
    var label = button.querySelector('[data-oss-offer-copy-label]');
    var code = state.code;
    if (!code) return;
    // Copy is clipboard-only: never reveal or focus hidden code entry.
    copyText(code).then(function () {
      if (!label) return;
      label.textContent = 'Copied';
      window.setTimeout(function () { label.textContent = 'Copy'; }, 1800);
    }).catch(function () {
      if (label) label.textContent = 'Select code';
      var codeNode = button.querySelector('code');
      if (codeNode && window.getSelection) {
        var range = document.createRange();
        range.selectNodeContents(codeNode);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    });
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-oss-cart-discount-input], [data-oss-ajax-cart-discount-input]')) return;
    var scope = event.target.closest('[data-oss-cart-discount-wrap], [data-oss-ajax-cart-discount-wrap]');
    if (!scope) return;
    delete scope.ossDiscountAttempt;
    var message = scope.querySelector('[data-oss-cart-discount-message], [data-oss-ajax-cart-discount-message]');
    if (message) { message.textContent = 'Select Apply to check eligibility.'; message.classList.remove('is-success', 'is-error'); }
    var button = scope.querySelector('[data-oss-cart-discount-submit], button[type="submit"]');
    if (button) button.textContent = 'Apply';
  });
  document.addEventListener('oss:cart-updated', function (event) {
    sync(event.detail && event.detail.cart);
  });
  document.addEventListener('oss:newsletter-success-ui', function () {
    // A successful form submission acknowledges the immediate local unlock;
    // persistent backend confirmation is handled independently by /contact.
    if (window.ossUnlockSubscriberOffer) window.ossUnlockSubscriberOffer();
  });
  document.addEventListener('oss:newsletter-subscribed', function () { sync(); });

  window.ossOfferSync = sync;
  window.ossPrepareCheckoutDiscount = prepareCheckoutDiscount;
  window.is20OffUnlocked = is20OffUnlocked;
  window.ossUnlockSubscriberOffer = function (cart) {
    var unlocked = unlock20Off();
    sync(cart || latestOfferCart);
    return unlocked;
  };
  function initialize() {
    // Event-driven coordination with existing drawer and checkout busy states. No polling.
    if (window.MutationObserver) {
      var observer = new MutationObserver(scheduleAutoApply);
      document.querySelectorAll('[data-oss-ajax-cart]').forEach(function (node) { observer.observe(node, { attributes: true, attributeFilter: ['class'] }); });
      document.querySelectorAll('.oss-ajax-cart__checkout, .oss-checkout-btn').forEach(function (node) { observer.observe(node, { attributes: true, attributeFilter: ['aria-disabled'] }); });
      document.querySelectorAll('[data-oss-ajax-cart-discount-form], [data-oss-cart-discount-wrap]').forEach(function (node) { observer.observe(node, { attributes: true, attributeFilter: ['aria-busy'] }); });
    }
    sync(latestOfferCart);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
